/**
 * @param {URL} from The origin URL.
 * @param {URL} to The destination URL.
 * @return {string} The relative URL.
 */
export function getRelativeUrl(from, to) {
  if (from.href === to.href) {
    return '';
  }
  if (from.origin !== to.origin) {
    return to.href;
  }

  const fromParts = from.pathname.split('/');
  const toParts = to.pathname.split('/');
  let lastCommonPart = -1;
  for (let i = 0; i < fromParts.length; i++) {
    if (fromParts[i] !== toParts[i]) {
      break;
    }
    lastCommonPart = i;
  }

  let startParts;
  if (lastCommonPart === fromParts.length - 1) {
    // from does not end with a slash (/foo, so we start with ./foo)
    startParts = ['.', fromParts[lastCommonPart]];
  } else {
    const remainingFromParts = fromParts.slice(lastCommonPart + 1);
    if (remainingFromParts.length < 2) {
      startParts = ['.'];
    } else {
      startParts = Array(remainingFromParts.length - 1).fill('..');
    }
  }

  const relativePath = startParts
    .concat(...toParts.slice(lastCommonPart + 1))
    .join('/');

  return relativePath + to.search + to.hash;
}
